import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../constants/api';
import { notification } from 'antd';
import AutoCompleteInput from './AutoCompleteInput';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';
import { decodeToken } from '../utils/TokenUtils';
import DataModal from './DataModal';
import { CURRENT_DATE } from '../constants';
const DataEntryTable = ({
  data,
  reportHeader,
  reportFooter,
  link,
  token,
  executionTime,
  setData,
}) => {
  const [columns, setColumns] = useState([]);
  const [data2, setData2] = useState([]);
  const { t } = useTranslation();
  // Step 1: Define the state to track which rows have been processed
  const [processedRows, setProcessedRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [showApiUpdateButton, setShowApiUpdateButton] = useState(false);
  // Initial state with the original data passed as a prop
  const [originalData, setOriginalData] = useState(data);
  const [filteredData, setFilteredData] = useState(data); // Filtered data to show based on search query
  const [failedData, setFailedData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const userlevel = decodeToken(token, 'userLevel');
  const userId = decodeToken(token, 'id');
  const updateApiValues = async () => {
    setLoading(true);

    const successfulRows = [];
    const failedRows = [];

    try {
      for (let i = 0; i < filteredData.length; i++) {
        const row = filteredData[i];
        const updatedRow = { ...row };
        const fetchPromises = [];
        let expression;

        for (const columnKey in row) {
          const parts = columnKey.split('~');

          if (parts[2] === 'api_url' && parts.length >= 3) {
            const targetKey = parts[3];
            const targetKeyExp = parts[4];

            const originalUrl = row[columnKey];
            //expression = '5*6=7';
            // console.log('expression', expression);
            fetchPromises.push(
              axios
                .get(`${API_URL}/${ENDPOINTS.SYS}/proxy`, {
                  params: { url: originalUrl },
                  timeout: 5000,
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((response) => {
                  const newValue = response.data?.[targetKey];
                  // console.log(
                  //   'newValue:',
                  //   newValue,
                  //   'response.data:',
                  //   response.data
                  // );
                  if (newValue !== undefined) {
                    const targetColumn = Object.keys(row).find(
                      (k) => k.split('~')[3] === targetKey
                    );

                    if (targetColumn) {
                      updatedRow[targetColumn] = newValue;
                    }
                  } else {
                    // ✅ If targetKey not found, treat as error
                    // console.log(
                    //   `Target key "${targetKey}" missing from response for ${originalUrl}`
                    // );
                    updatedRow[`error_${targetKey}`] = true;
                  }
                })
                .catch((err) => {
                  console.log(`Failed to fetch ${originalUrl}`, err.message);
                  updatedRow[`error_${targetKey}`] = true;
                })
            );
          }
        }

        await Promise.allSettled(fetchPromises);

        // ✅ After API fetches, calculate using your function
        // calculateExpression(
        //   expression, // you should define it before
        //   i, // current row index
        //   updatedRow, // current row
        //   filteredData, // original data or updatedData
        //   setFilteredData, // setter
        //   true // supportNegative maybe true (or your flag)
        // );
        const hasError = Object.keys(updatedRow).some((key) =>
          key.startsWith('error_')
        );

        if (hasError) {
          failedRows.push(updatedRow);
        } else {
          successfulRows.push(updatedRow);
        }
      }

      setFilteredData(successfulRows);
      setOriginalData(successfulRows);

      setFailedData(failedRows);
    } catch (error) {
      console.error('Unexpected error:', error);
    } finally {
      setLoading(false);
    }
  };

  // console.log('filteredData:', filteredData);

  // Create a ref for the input element
  const inputRef = useRef(null);

  useEffect(() => {
    // Fetch column definitions and data from the API
    const columns = Object.keys(data[0]);

    //columsn with dropdown
    const cols = columns.map((col) => {
      const originalCol=col;
      const parts = col.split('~');
      const columnName = col;
      const header = parts[0]; // Display label
      const key = parts[1] || parts[0]; // Key used for row data
      const type = parts[2]; // 'editable', 'dropdown', 'hide'
      const inputId = parts[3]; // Used to fetch dropdown options
      const colIndex = parts[4];

      const isDropdown = type?.includes('dropdown');
      const isEditable = type === 'editable' || type === 'api_url';
      const isHidden = type === 'hide';
      const stylePart = parts.find((p) => p.startsWith('style='));
      const style = stylePart ? stylePart.replace('style=', '') : null;
      return {
        columnName,
        header,
        key,
        type,
        inputId,
        colIndex,
        isDropdown,
        editable: isEditable,
        visible: !isHidden,
        dropdownOptions: isDropdown ? [] : null,
        style,
        originalCol
      };
    });

    setColumns(cols);

    // check if has api_url column and show button to call update api url
    if (data?.length > 0) {
      const firstRow = data[0];
      const hasApiUrlColumn = Object.keys(firstRow).some(
        (key) => key.split('~')[2] === 'api_url'
      );
      setShowApiUpdateButton(hasApiUrlColumn);
      // console.log('button shows: ', hasApiUrlColumn);
    } else {
      // console.log('button not shows');
    }

    // const fetchAllDropdowns = async (cols) => {
    //   for (const col of cols) {
    //     if (col.isDropdown && col.inputId) {
    //       // console.log('col:', col);
    //       const url = `${API_URL}/${ENDPOINTS.SYS}/get-dropdown/${col.inputId}`;

    //       try {
    //         const response = await axios.get(url, {
    //           headers: {
    //             Authorization: token ? `Bearer ${token}` : '',
    //           },
    //         });
    //         const options = response.data;
    //         //console.log('url:', url, 'response:', response.data);

    //         setColumns((prevColumns) =>
    //           prevColumns.map((c) =>
    //             c.key === col.key ? { ...c, dropdownOptions: options } : c
    //           )
    //         );
    //       } catch (err) {
    //         console.error(`Dropdown fetch failed for ${col.inputId}`, err);
    //       }
    //     }
    //   }
    // };
    // Replace your existing fetchAllDropdowns function inside useEffect with this:

  const fetchAllDropdowns = async (cols) => {
  // Map to hold all dropdown options keyed by inputId
  const optionsMap = {};
  // Map to hold default selected values keyed by columnName
  const defaultValuesMap = {};

  for (const col of cols) {
    if (col.isDropdown && col.inputId) {
      const url = `${API_URL}/${ENDPOINTS.SYS}/get-dropdown/${col.inputId}`;

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });
        const options = response.data;
        optionsMap[col.key] = options;

        // 1. Find the option marked as selected in API response
        const defaultSelected = Array.isArray(options)
          ? options.find((opt) => opt.selected === 'selected')
          : null;

        // 2. Extract selected value ID (handles .id, .value, or raw first value)
        if (defaultSelected) {
          const val =
            defaultSelected.id ??
            defaultSelected.value ??
            defaultSelected[Object.keys(defaultSelected)[0]];

          defaultValuesMap[col.columnName] = String(val);
        }
      } catch (err) {
        console.error(`Dropdown fetch failed for ${col.inputId}`, err);
      }
    }
  }

  // 3. Update Columns with options
  setColumns((prevColumns) =>
    prevColumns.map((c) =>
      optionsMap[c.key] ? { ...c, dropdownOptions: optionsMap[c.key] } : c
    )
  );

  // 4. Pre-fill data and filteredData if cell values are currently empty
  if (Object.keys(defaultValuesMap).length > 0) {
    const updateRowsWithDefaults = (prevRows) =>
      prevRows.map((row) => {
        const updatedRow = { ...row };
        Object.keys(defaultValuesMap).forEach((colName) => {
          // Fill default if row value is null, undefined, or empty string
          if (
            updatedRow[colName] === undefined ||
            updatedRow[colName] === null ||
            updatedRow[colName] === ''
          ) {
            updatedRow[colName] = defaultValuesMap[colName];
          }
        });
        return updatedRow;
      });

    // Update both main state arrays using functional updates
    setOriginalData((prev) => updateRowsWithDefaults(prev));
    setData((prev) => updateRowsWithDefaults(prev));
    setFilteredData((prev) => updateRowsWithDefaults(prev));
  }
};

    if (cols.length) {
      // console.log('length is true');
      fetchAllDropdowns(cols);
    } else {
      // console.log('length is false');
    }
  }, []);

  const [search, setSearch] = useState('');

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(e.target.value);

    // Filter data based on the search query
    const filtered = originalData.filter((row) =>
      Object.values(row).some((val) =>
        val?.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

 const autoGenerateRefNo = (rowIndex, updatedData) => {
  const currentRow = updatedData[rowIndex];

  const refKey = Object.keys(currentRow).find(k =>
    k.toLowerCase().includes('ref_no')
  );

  if (!refKey) return;

  let maxRef = 0;

  // 🔍 Search all previous rows and get MAX ref_no
  for (let i = 0; i < updatedData.length; i++) {
    if (i === rowIndex) continue; // skip current row

    const val = Number(updatedData[i][refKey]);
    if (!isNaN(val) && val > maxRef) {
      maxRef = val;
    }
  }

  if (maxRef > 0) {
    currentRow[refKey] = maxRef + 1;
  }
};

  const [loading, setLoading] = useState(false);

  const handleEdit = async (e, rowIndex2, colData, row, colIndex) => {
    try {
      const columnName = colData.columnName;
      const updatedData = [...data];
      const updatedFiltered = [...filteredData];

      // Get new value based on input type
      let text = e.target.textContent;
      if (
        colData.type.includes('dropdown') ||
        colData.type === 'autocomplete' ||
        colData.type === 'input'
      ) {
        text = e.target.value;
      }

      // Custom function to find original index by comparing key fields
      const findMatchingRowIndex = (filteredRow, originalData) => {
        return originalData.findIndex((origRow) => {
          const keysToCompare = Object.keys(filteredRow).filter(
            (k) => !k.includes('~options') // ignore auto-injected dropdown options
          );
          return keysToCompare.every(
            (key) => filteredRow[key] === origRow[key]
          );
        });
      };

      const rowIndex = findMatchingRowIndex(row, updatedData);
      if (rowIndex === -1) return;

      // Handle 'load-dropdown' type
      if (colData.type === 'load-dropdown') {
        try {
          setLoading(true);
          const url = `${API_URL}/${ENDPOINTS.SYS}/load-dropdown/${colData.inputId}/${text}`;
          const response = await axios.get(url, {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          });

          const newOptions = response.data.results;

          const targetColIndex = parseInt(colData.colIndex, 10);
          const optionsKey = `${columns[targetColIndex].columnName}~options`;

          // Apply to both full and filtered data
          updatedData[rowIndex][optionsKey] = newOptions;
          updatedFiltered[rowIndex2][optionsKey] = newOptions;
        } catch (error) {
          console.error('Error fetching dropdown:', error);
        } finally {
          setLoading(false);
        }
      }

      // Update the value in both data and filteredData
      updatedData[rowIndex][columnName] = text;
      updatedFiltered[rowIndex2][columnName] = text;

      if (columnName.toLowerCase().includes('current_read')) {
        autoGenerateRefNo(rowIndex, updatedData);
      }
      console.log('Updated:', columnName, ':', text);
      console.log('Updated Row:', updatedData[rowIndex]);
      setOriginalData(updatedData)
      setData(updatedData);
      setFilteredData(updatedFiltered);

      // Handle expressions
      const expression = columnName?.split('~')[3]?.split(',');
      const isSupportNegative = columnName?.split('~')[4] ?? '1';

      if (expression) {
        expression.forEach((expr) => {
          if (expr) {
            calculateExpression(
              expr,
              rowIndex,
              row,
              updatedData,
              setData,
              isSupportNegative
            );
          }
        });

        // Auto-submit if "autotick" is in expression
        if (expression[0]?.includes('autotick')) {
          handleSubmit(row, rowIndex);
        }
      }
    } catch (err) {
      alert(err);
      console.error('Edit error:', err);
    }
  };
  console.log('filtered Data:', filteredData);


const evaluateCellRule = (rule, value, row, currentColumnIndex) => {
  if (!rule) return {};

  const keys = Object.keys(row);
  console.log("row: ",row);
  // Helper to extract value from row by numeric index, using live value when applicable
  const getValByIndex = (token) => {
    const idx = Number(token.trim());
    console.log("idx: ",idx," value : ",row[keys[idx+1]]);
    if (!isNaN(idx)) {
      // 1. If checking the current edited column, use the live 'value'
      if (currentColumnIndex !== undefined && idx === currentColumnIndex) {
        return Number(value) || 0;
      }
      console.log("current columnindex: ",currentColumnIndex);
      // 2. Otherwise read from the row data
      if (keys[idx] !== undefined) { 
        // Note: SQL 1-based index (Index 6 -> keys[5])
        return Number(row[keys[idx+1]]) || 0;
      }
    }
    return Number(token) || 0; // Static fallback numbers
  };

  // Split ternary logic: condition ? thenResult : elseResult
  const ternaryMatch = rule.match(/(.+?)\?(.+?)\:(.+)/);
    // console.log("ternary match: ",ternaryMatch);
  if (ternaryMatch) {
    const [, condition, thenResult, elseResult] = ternaryMatch;

    // Matches numbers with operators: e.g. "6<5", "6<7"
    // console.log("condition : ",condition," thenresult: ",thenResult," elseresult: ",elseResult);
    const condMatch = condition.match(/^(\d+)\s*(<=|>=|==|!=|<|>)\s*(\d+)$/);
    // console.log("condion match: ",condMatch);
    if (condMatch) {
      const [, leftIdx, op, rightIdx] = condMatch;

      // Extract values dynamically
      const leftVal = getValByIndex(leftIdx)
        console.log("value: ",value," leftval :",leftVal);
        
      const rightVal = getValByIndex(rightIdx);
      console.log("right val: ",rightVal);
      let isConditionMet = false;
      switch (op) {
        case '<':  isConditionMet = leftVal < rightVal; break;
        case '<=': isConditionMet = leftVal <= rightVal; break;
        case '>':  isConditionMet = leftVal > rightVal; break;
        case '>=': isConditionMet = leftVal >= rightVal; break;
        case '==': isConditionMet = leftVal == rightVal; break;
        case '!=': isConditionMet = leftVal != rightVal; break;
        default:   isConditionMet = false;
      }

      const styleStr = (isConditionMet ? thenResult : elseResult).trim();

      // Convert style string (color=#dc3545) into JS Object
      const styleObj = {};
      styleStr.split(',').forEach((s) => {
        const [k, v] = s.split('='); 
        if (k && v) {
          styleObj[k.trim()] = v.trim();
        }
      });

      return styleObj;
    }
  }

  return {};
};

const toggleSelectRow = (row) => {
  const newSelected = new Set(selectedRows);
  if (newSelected.has(row)) {
    newSelected.delete(row);
  } else {
    newSelected.add(row);
  }
  setSelectedRows(newSelected);
};

const toggleSelectAll = () => {
  if (selectedRows.size === sortedData.length) {
    setSelectedRows(new Set());
  } else {
    setSelectedRows(new Set(sortedData));
  }
};

  const [statementModalVisible, setStatementModalVisible] = useState(false);
    const [statement, setSatetment] = useState([]);
  
    // Handle opening the modal
   const openStatementlModal = (id, route = null,bodyObj) => {
      fetchStatement(id, route,bodyObj);
      setStatementModalVisible(true);
  };
  
  const fetchStatement = async (id, customRoute = null,bodyObj) => {
      const top_navbar_statement_link_id = decodeToken(
          token,
          'top_navbar_statement_link_id'
      );
      
      let statementUrl;
  
      if (customRoute) {
          // ← Route-ka SQL-ka ka yimid ayaa la isticmaalaa
          statementUrl = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/${customRoute}`;
      } else if (API_URL.includes('imaamshafici') || API_URL.includes('aqoonkaal')) {
          statementUrl = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/student-statement`;
      } else {
          const endpoint = `${API_URL}/${ENDPOINTS.SYS}/get-top-navbar-statement/${top_navbar_statement_link_id}`;
          const res = await axios.get(endpoint, {
              headers: { Authorization: token ? `Bearer ${token}` : '' },
          });
          const statement_route = res.data.link[0]?.route || 'customer-statement';
          statementUrl = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/${statement_route}`;
      }
      let values={};
      if (Object.keys(bodyObj).length>0) {
        values=bodyObj;
      }
      else{
        values = {
          _id: id,
          from: '0000-00-00',
          to: CURRENT_DATE,
          user_id: userId,
      };
      }
      
  
      const response = await axios.post(statementUrl, values, {
          headers: { Authorization: token ? `Bearer ${token}` : '' },
      });
  console.log(response.data);
      setSatetment(response.data.data);
  };
    const closeStatementModal = () => {
      setStatementModalVisible(false);
    };
  

 function calculateExpression(
  expression,
  rowIndex,
  row,
  updatedData,
  setData,
  isSupportNegative
) {
  if (!expression) return;

  const keys = Object.keys(row);
  const rules = expression.split(',');

  for (let rule of rules) {
    if (rule.startsWith('rule=')) continue;

    const [left, right] = rule.split('=');
    if (!left || right === undefined) continue;

    const opMatch = left.match(/[-+*/]/);
    if (!opMatch) continue;

    const op = opMatch[0];
    const [i1, i2] = left.split(op).map(v => Number(v.trim()));
    const target = Number(right);

    const v1 = Number(updatedData[rowIndex][keys[i1]]) || 0;
    const v2 = Number(updatedData[rowIndex][keys[i2]]) || 0;

    let result = 0;
    switch (op) {
      case '+': result = v1 + v2; break;
      case '-': result = v1 - v2; break;
      case '*': result = v1 * v2; break;
      case '/': result = v2 ? v1 / v2 : 0; break;
    }

    if (op === '-' && result < 0 && isSupportNegative === '0') {
      notification.error({ message: 'The difference is negative.' });
      return;
    }

    updatedData[rowIndex][keys[target]] = Number(result.toFixed(2));
  }
  const ratesKey  = keys.find(k => k.toLowerCase().includes('rates~rates~hide'));
  const rateKey   = keys.find(k => k.toLowerCase().includes('rate~rate'));
  const usageKey  = keys.find(k => k.toLowerCase().includes('usage'));
  const amountKey = keys.find(k => k.toLowerCase().includes('amount~amount'));

  let finalAmount;

  if (ratesKey && usageKey && amountKey && rateKey) {
    const usage = Number(updatedData[rowIndex][usageKey]) || 0;
    const rate  = pickRate(updatedData[rowIndex][ratesKey] || '', usage);

    finalAmount = rate > 0 ? usage * rate : 0;
    updatedData[rowIndex][rateKey] = Number(rate.toFixed(2));
    updatedData[rowIndex][amountKey] = Number(finalAmount.toFixed(2));
  }

  const ruleRaw = rules.find(r => r.startsWith('rule='))?.slice(5);
  if (ruleRaw) {
    const normalized = ruleRaw.replace(/'%'/g, '?');

    const ternary = normalized.match(/(.+?)\?(.+?)\:(.+)/);
    if (ternary) {
      const [, conditionRaw, thenExpr, elseExpr] = ternary;

      const conditionParts = conditionRaw.split(/\s*(?:&&|\|\|)\s*/);
      const logicalOps = conditionRaw.match(/&&|\|\|/g) || [];

      const results = conditionParts.map(p => {
        const m = p.match(/^(\d+)\s*(<=|>=|==|<|>)\s*(\d+)$/);
        if (!m) return false;

        const [, idx, op, staticVal] = m;
        const leftVal  = Number(updatedData[rowIndex][keys[idx]]) || 0;
        const rightVal = Number(staticVal);

        switch (op) {
          case '<=': return leftVal <= rightVal;
          case '>=': return leftVal >= rightVal;
          case '<':  return leftVal <  rightVal;
          case '>':  return leftVal >  rightVal;
          case '==': return leftVal == rightVal;
          default: return false;
        }
      });

      let conditionResult = results[0];
      logicalOps.forEach((op, i) => {
        conditionResult =
          op === '&&'
            ? conditionResult && results[i + 1]
            : conditionResult || results[i + 1];
      });

      const selected = conditionResult ? thenExpr : elseExpr;
      const assignMatch = selected.match(/(.+?)=(\d+)/);

      if (assignMatch) {
        let expr = assignMatch[1].replace(/['"]/g, '');
        const targetIdx = Number(assignMatch[2]);
        let value = 0;

        const math = expr.match(/^(\d+)\s*([\+\-\*\/])\s*(\d+)$/);
        if (math) {
          const [, i1, op, i2] = math;
          const v1 = Number(updatedData[rowIndex][keys[i1]]) || 0;
          const v2 = Number(updatedData[rowIndex][keys[i2]]) || 0;

          switch (op) {
            case '+': value = v1 + v2; break;
            case '-': value = v1 - v2; break;
            case '*': value = v1 * v2; break;
            case '/': value = v2 ? v1 / v2 : 0; break;
          }
        } else {
          value = Number(expr);
        }

        updatedData[rowIndex][keys[targetIdx]] = Number(value.toFixed(2));
      }
    }
  }

  setData([...updatedData]);
}




  function pickRate(rateStr, value) {
    if (!rateStr) return 0;
    return (
      rateStr
        .split('|')
        .map((r) => {
          const [rate, range] = r.split('*');
          const [min, max] = range.split('-').map(Number);
          return { rate: parseFloat(rate), min, max };
        })
        .find((r) => value >= r.min && value <= r.max)?.rate || 0
    );
  }
  const handleTab = (e) => {
  if (e.key !== 'Tab') return;

  e.preventDefault(); // 🚫 stop default browser tabbing

  const editableElements = Array.from(
    document.querySelectorAll('.editable-cell')
  ).filter(
    el => !el.hasAttribute('disabled') && el.offsetParent !== null
  );

  const currentIndex = editableElements.indexOf(e.target);

  if (currentIndex === -1) return;

  const nextIndex = e.shiftKey
    ? currentIndex - 1
    : currentIndex + 1;

  if (editableElements[nextIndex]) {
    editableElements[nextIndex].focus();
  }
};

  // console.log('rowData:', rowData);
  const handleSubmit = async (row, rowIndex, skipRemove = false) => {
    const filteredRow = Object.keys(row).reduce((acc, key) => {
      const parts = key.split('~');

      // Skip if the last part is "options"
      if (parts[parts.length - 1] === 'options') return acc;

      // Only include keys that have a valid second part (the column name)
      if (parts.length >= 2) {
        acc[parts[1]] = row[key]; // Use the column name part as the key
      }
      return acc;
    }, {});

    const route = filteredRow.api_route;
    delete filteredRow.api_route;
    console.log(
      'row:',
      row,
      'Filtered row for submission:',
      filteredRow,
      'route:',
      route
    );
    var insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/${route}`;

    const response = await axios.post(insertUrl, filteredRow, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
     if (userlevel === 'developer') {
            console.log(
      'url:',
      insertUrl,
      'request:',
      filteredRow,
      'response:',
      response.data
    );
    }
    const { success, message } = response.data;
    if (success === 1) {
      setProcessedRows((prev) => [...prev, rowIndex]); // Track the processed row by ID
      // setProcessedRowsResponse((prev) => [...prev, rowIndex]); // Track the processed row by ID
    //   if (!skipRemove) {
    //   // Remove the row from the original data
    //   const updatedData = originalData.filter(
    //     (dataRow) => JSON.stringify(dataRow) !== JSON.stringify(row)
    //   );

    //   // Update the original data
    //   setOriginalData(updatedData);

    //   // If the removed row is in the filteredData, we should also update filteredData
    //   const updatedFilteredData = filteredData.filter(
    //     (dataRow) => JSON.stringify(dataRow) !== JSON.stringify(row)
    //   );

    //   // Update the filtered data as well (it can stay in sync with the original data)
    //   setFilteredData(updatedFilteredData);
    // }
    if (!skipRemove) {
  setOriginalData((prev) => prev.filter((r) => r !== row));
  setFilteredData((prev) => prev.filter((r) => r !== row));
  setSelectedRows((prev) => {
    const next = new Set(prev);
    next.delete(row);
    return next;
  });
}
      // Focus the input field when this event is triggered
      // if (inputRef.current) {
      //   inputRef.current.focus();
      // }
      setSearch('');
      notification.success({ message: message });
    } else {
      notification.error({ message: message });
    }
  };

  const renderCell = ({ col, row, rowIndex, colIndex, handleEdit }) => {
    const value = row[col.columnName] ?? '';
    // Evaluate dynamic cell rules based on column index
  const dynamicRulesStyle = evaluateCellRule(col.style, value, row);
  // Combine baseline styling with dynamic index rule overrides
  // console.log("dynamic reles type: ",dynamicRulesStyle);
  const dynamicCellStyle = {
   
    ...dynamicRulesStyle, // Overrides text color/background dynamically
  };
//  console.log("dynamic styles: ",dynamicCellStyle,"col: ",col);
    // Autocomplete
    if (col.type === 'autocomplete') {
      return (
        <AutoCompleteInput
          col={col}
          value={value}
          rowIndex={rowIndex}
          colIndex={colIndex}
          onChange={(id, name) => {
            handleEdit({ target: { value: id } }, rowIndex, col, row, colIndex);
            // row[col.columnName] = name;
          }}
        />
      );
    }

    // Dropdown
    if (col.isDropdown) {
      const options =
        row[`${col.columnName}~options`] || col.dropdownOptions || [];
        const defaultSelected = col.dropdownOptions?.find(
    (option) => option.selected === 'selected'
  );

  // 2. Resolve final controlled value (use row state 'value', fallback to default option id, or empty string)
    const currentValue = value ?? defaultSelected?.id ?? defaultSelected?.value ?? "";
    console.log("currentvalue: ",currentValue);
      return (
        <select
          className="form-select form-select-sm editable-cell"
          tabIndex={0}
          onKeyDown={(e) => handleTab(e)}
          value={currentValue}
          onChange={(e) => handleEdit(e, rowIndex, col, row, colIndex)}
        >
          <option value="">-- Select --</option>
          {options.map((opt, i) => (
            <option key={i} value={opt.id}>
              {opt.name}
            </option>
          ))}
        </select>
      );
    }

    // Standard input
    if (col.type === 'input' && col.inputId) {
      return (
        <input
          type={col.inputId}
          className="form-control form-control-sm editable-cell"
          tabIndex={0}
          onKeyDown={(e) => handleTab(e)}
          style={dynamicCellStyle}
          value={value}
          onChange={(e) => handleEdit(e, rowIndex, col, row, colIndex)}
        />
      );
    }

    // Editable content
    if (col.editable) {
      return (
        <div
          className="editable-cell"
          tabIndex={0}
          onKeyDown={(e) => handleTab(e)}

          contentEditable
          suppressContentEditableWarning
          onBlur={(e) => handleEdit(e, rowIndex, col, row, colIndex)}
          style={dynamicCellStyle}
        >
          {value}
        </div>
      );
    }

    // Non-editable: detect URLs and make them clickable
    if (
      typeof value === 'string' &&
      (value.includes('http://') || value.includes('https://'))
    ) {
      return (
        <a href={value} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      );
    }

    // Default: just show value
    return value;
  };

  // console.log(
  //   'data length: ',
  //   data?.length,
  //   ' filtered length: ',
  //   filteredData.length
  // );

  // console.log('filtered data:', filteredData);

  const exportToExcel = (data, title) => {
    // Step 1: Map data to have only first part of keys
    const mappedData = data.map((row) => {
      const newRow = {};
      for (const key in row) {
        const firstPart = key.split('~')[0]; // get the first part before ~
        newRow[firstPart] = row[key];
      }
      return newRow;
    });

    // Step 2: Create sheet
    const ws = XLSX.utils.json_to_sheet(mappedData);

    // Step 3: Create workbook and export
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');
    XLSX.writeFile(wb, title + '.xlsx');
  };
  // ✅ Filter a row: remove ~options keys & extract proper keys
  const filterRow = (row) => {
    return Object.keys(row).reduce((acc, key) => {
      const parts = key.split('~');
      if (parts[parts.length - 1] === 'options') return acc;
      if (parts.length >= 2) {
        acc[parts[1]] = row[key];
      }
      return acc;
    }, {});
  };
//   const handleSubmitAll = async () => {
//   const rows = Array.from(selectedRows)
//     .map(i => filteredData[i])
//     .filter(Boolean);

//   const successfulRows = [];

//   for (const row of rows) {
//     const res = await handleSubmit(row, null, true); // ⬅ skip removal
//     if (res !== false) successfulRows.push(row);
//   }

//   // 🔥 Remove ALL successful rows once
//   const updatedOriginal = originalData.filter(
//     r => !successfulRows.includes(r)
//   );

//   const updatedFiltered = filteredData.filter(
//     r => !successfulRows.includes(r)
//   );

//   setOriginalData(updatedOriginal);
//   setFilteredData(updatedFiltered);
//   setSelectedRows(new Set());

//   notification.success({
//     message: `${successfulRows.length} rows submitted successfully`,
//   });
// };

const handleSubmitAll = async () => {
  const rowsToSubmit = Array.from(selectedRows);
  const successfulRows = [];

  for (const row of rowsToSubmit) {
    const res = await handleSubmit(row, true);
    if (res !== false) successfulRows.push(row);
  }

  setOriginalData((prev) => prev.filter((r) => !successfulRows.includes(r)));
  setFilteredData((prev) => prev.filter((r) => !successfulRows.includes(r)));
  setSelectedRows(new Set());

  notification.success({
    message: `${successfulRows.length} rows submitted successfully`,
  });
};

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        // Toggle direction if the same column is clicked again
        return {
          key,
          direction: prev.direction === 'asc' ? 'desc' : 'asc',
        };
      }
      return { key, direction: 'asc' }; // Default to ascending when new column clicked
    });
  };

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return filteredData;
    return [...filteredData].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];
      if (aVal === bVal) return 0;
      if (sortConfig.direction === 'asc') {
        return aVal > bVal ? 1 : -1;
      } else {
        return aVal < bVal ? 1 : -1;
      }
    });
  }, [filteredData, sortConfig]);

  return (
    <div className=" ">
      <div className="row">
        <div className="col-9">
          {' '}
          {showApiUpdateButton && (
            <button
              onClick={updateApiValues}
              className="btn btn-danger"
              disabled={loading}
            >
              {loading ? '⏳ Updating...' : '🔄 Update API Values'}
            </button>
          )}
          <button
            onClick={() => exportToExcel(filteredData, `${link.page_title}`)}
            className="btn btn-primary"
          >
            Export Excel
          </button>
          {failedData && failedData.length > 0 && (
            <button
              onClick={() =>
                exportToExcel(failedData, `${link.page_title}-failed`)
              }
              className="btn btn-danger"
            >
              Export Errors {failedData?.length}
            </button>
          )}
        </div>
        <div className="col-3">
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={handleSearch}
            className="form-control mb-3"
            style={{ maxWidth: '300px' }} // Optional: Limit max width for better alignment
            ref={inputRef} // Attach the ref here
          />
        </div>
      </div>
      <table className="table table-bordered">
        <thead className="table-dark">
          <tr>
            {/* <th>
              <input
                type="checkbox"
                checked={selectedRows.size === filteredData.length}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedRows(new Set(filteredData.map((_, i) => i)));
                  } else {
                    setSelectedRows(new Set());
                  }
                }}
              />
            </th> */}
            <th style={{ width: '40px' }} className="text-center">
  <input
    type="checkbox"
    className="form-check-input"
    checked={
      sortedData.length > 0 &&
      selectedRows.size === sortedData.length
    }
    onChange={toggleSelectAll}
  />
</th>

            {/* {columns
              .filter((col) => col.visible && col.key !== 'color') // Ignore "color" column
              .map((col) => (
                <th key={col.key}>{col.header}</th>
              ))} */}
            {columns
              .filter((col) => col.visible && col.key !== 'color') // Ignore "color" column
              .map((col) => (
                <th
                  key={col.key}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleSort(col.key)}
                >
                  {t(col.header)}
                  {sortConfig.key === col.key
                    ? sortConfig.direction === 'asc'
                      ? ' ▲'
                      : ' ▼'
                    : null}
                </th>
              ))}
            <th>
              {selectedRows.size > 0 && (
                <button
                  className="btn btn-primary mb-2"
                  onClick={handleSubmitAll}
                >
                  Submit Selected Rows ({selectedRows.size})
                </button>
              )}
            </th>
          </tr>
        </thead>
        {/* <tbody>
          {sortedData &&
            sortedData.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className={
                  row.color ? `row-color-${row.color.trim().toLowerCase()}` : ''
                }
              >
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.has(rowIndex)}
                    onChange={() => {
                      setSelectedRows((prev) => {
                        const updated = new Set(prev);
                        if (updated.has(rowIndex)) {
                          updated.delete(rowIndex);
                        } else {
                          updated.add(rowIndex);
                        }
                        return updated;
                      });
                    }}
                  />
                </td>
                {columns
                  .filter((col) => col.visible && col.key !== 'color')
                  .map((col, colIndex) => (
                    <td
                      key={col.key}
                      onDoubleClick={(e) => {
                // Check if the column has 'showDetail' and open the modal
               if (col.originalCol.includes('statement')) {
                const parts = col.originalCol.split('~');
                const statementIndex = parts.findIndex(p => p === 'statement');
                const route = parts[statementIndex + 1] || null; // ← route-ka ka dambeeya 'statement'
                const bodyKey=Object.keys(row).find(k=>k.includes('body'));
                let bodyObj={};
                if (bodyKey) {
                  const params = new URLSearchParams(row[bodyKey]);
                  bodyObj = Object.fromEntries(params.entries());
                }

    console.log("body: ",row," bodykey: ",bodyKey," bodyobj: ",bodyObj);
    openStatementlModal(row[col.columnName], route,bodyObj);
    // console.log('parts',parts, 'route:', route,'key',row[col.columnName]);
}
            
              }}
                      style={
                        col.editable ||
                        col.isDropdown ||
                        col.type === 'autocomplete'
                          ? { backgroundColor: '#f9f9f9' }
                          : {}
                      }
                    >
                      {renderCell({ col, row, rowIndex, colIndex, handleEdit })}
                    </td>
                  ))}

                <td>
                  <button
                    className="btn btn-sm btn-success"
                    onClick={() => handleSubmit(row, rowIndex)}
                  >
                    ✅
                  </button>
                </td>
              </tr>
            ))}
        </tbody> */}
        <tbody>
  {sortedData &&
    sortedData.map((row, rowIndex) => (
      <tr
        key={rowIndex}
        className={
          row.color ? `row-color-${row.color.trim().toLowerCase()}` : ''
        }
      >
        <td>
          <input
            type="checkbox"
            checked={selectedRows.has(row)}
            onChange={() => {
              setSelectedRows((prev) => {
                const updated = new Set(prev);
                if (updated.has(row)) {
                  updated.delete(row);
                } else {
                  updated.add(row);
                }
                return updated;
              });
            }}
          />
        </td>
        {columns
          .filter((col) => col.visible && col.key !== 'color')
          .map((col, colIndex) => (
            <td
              key={col.key}
              onDoubleClick={(e) => {
                if (col.originalCol.includes('statement')) {
                  const parts = col.originalCol.split('~');
                  const statementIndex = parts.findIndex((p) => p === 'statement');
                  const route = parts[statementIndex + 1] || null;
                  const bodyKey = Object.keys(row).find((k) => k.includes('body'));
                  let bodyObj = {};
                  if (bodyKey) {
                    const params = new URLSearchParams(row[bodyKey]);
                    bodyObj = Object.fromEntries(params.entries());
                  }

                  console.log(
                    'body: ',
                    row,
                    ' bodykey: ',
                    bodyKey,
                    ' bodyobj: ',
                    bodyObj
                  );
                  openStatementlModal(row[col.columnName], route, bodyObj);
                }
              }}
              style={
                col.editable ||
                col.isDropdown ||
                col.type === 'autocomplete'
                  ? { backgroundColor: '#f9f9f9' }
                  : {}
              }
            >
              {renderCell({ col, row, rowIndex, colIndex, handleEdit })}
            </td>
          ))}

        <td>
          <button
            className="btn btn-sm btn-success"
            
            onClick={() => handleSubmit(row)}
          >
            ✅
          </button>
        </td>
      </tr>
    ))}
</tbody>
      </table>
      {executionTime !== null && (
        <p>
          Request executed in: {executionTime.toFixed(2)} sec - Total rows:
          {filteredData && filteredData.length} rows
        </p>
      )}
      <DataModal
              title={'Statement'}
              data={statement}
              // editDelPermission={editDelPermission}
              isOpen={statementModalVisible}
              onRequestClose={closeStatementModal}
            />
    </div>
  );
};

export default DataEntryTable;
